/**
 * Pre-pack label location. Hub carton labels are 4x6 at 300 DPI.
 * ABB carton and box labels resolve separately at 203 DPI.
 */

export { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";

import { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";
import { useZplPrintLocation } from "@/lib/zplPrintLocation";

export const PREPACK_ZPL_PRINTER_STORAGE_KEY = ZPL_PRINTER_STORAGE_KEYS.prepack;

export function usePrepackZplPrinter(): ReturnType<typeof useZplPrintLocation> {
  return useZplPrintLocation({
    storageKey: ZPL_PRINTER_STORAGE_KEYS.prepack,
    labelSize: "4x6",
    dpi: 300,
  });
}
